import {
  audioDetailArgs,
  audioSummaryArgs,
} from '@listening/frontend/query/audio-detail';
import { eq } from '@/runtimes/effect-query';

// App-side eq-bound query options for route loaders (`ensureQueryData`). The
// reusable pieces — args, the `useAudioDetailedView` hook, and
// `getAudioDetailFromCache` — live in `@listening/frontend/query/audio-detail`;
// this only binds the app runtime (`eq`) for the loader prefetch path.

export const audioDetailQueryOptions = (audioId: string | undefined) =>
  eq.queryOptions(audioDetailArgs(audioId));

export const audioSummaryQueryOptions = (audioId: string | undefined) =>
  eq.queryOptions(audioSummaryArgs(audioId));
